import React from 'react';
import { AudioTrackTemplate } from '../../_templates/AudioTrackTemplate';

export const AudioTrack = () => {
  return (
    <AudioTrackTemplate />
  );
};